




















































































import {Vue, Component, Prop} from 'vue-property-decorator';
import {ncpPopup} from '@/utils/ncp';
import { ComponentItemsClaimDataType } from '@/views/claim/components/dataType/ComponentDataType'
import {  
MallOption, 
CustomerDemands,
GetExchangeProductsProductNoRequest,
MaxBuyCountInfo
 } from 'supporter';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
@Component({
  components: {CompSelectBox},
})
export default class ComponentProductExchange extends Vue { //F

  @Prop({required: true})
  private orderOptionsApply!: ComponentItemsClaimDataType

  @Prop({required: false})
  private partnerNo!: string;

  @Prop({required: false})
  private memberNo!: string;

  @Prop({required: true})
  private pageName!: string;

  @Prop({required: false})
  private mallNo!: string;

  @Prop({required: true})
  public checkedExchangesProduct: boolean;

  private noData:boolean = true;
  private saleCnt: number = 0;
  private deleteCheck: boolean = false;
  private accumulationUsed: boolean = false;
  public mallOptionValue: string = '';
  public mallOptionValueArr: any[] = [];
  public exchangeProductOptions: any[] = [];
  private minBuyCount: number = 0;
  private maxBuyPeriodCount: number = 0;
  private maxBuyPersonCount: number = 0;
  private maxBuyDays: number = 0;
  private maxBuyTimeCount: number = 0;
  private totalBuyCount: number = 0;
  private beforeExchangeCnt: number = 0;

  private get disableExchangeCntInput(){
    return this.mallOptionValue === ''
  }

  private onClickDiffentProduct(){
    if(this.checkedExchangesProduct === true) {
      if (!confirm(this.$t('CLAIM_EXCHANGEPOPUP_CONFIRM3').toString())){
        return;
      }
    }
    (window as any).displayExchangeProductOptionInputArea = this.callback;
    ncpPopup(`/claim/exchangeProduct?mallNo=${this.mallNo}&partnerNo=${this.partnerNo}&callBackName=displayExchangeProductOptionInputArea`, this.$t('CLAIM_EXCHANGEPRODUCT_PAGETITLE'), 1250, 1024);
  }

  private onClickSameProduct(){
    if(this.checkedExchangesProduct === true) {
      if (!confirm(this.$t('CLAIM_EXCHANGEPOPUP_CONFIRM3').toString())){
        return;
      }
    }

    let productNo: number = this.orderOptionsApply.claimableOptions[0].mallProductNo
    let request: GetExchangeProductsProductNoRequest = {
      pathParams: {
        productNo: productNo.toString(),
      },
      params: {
        mallNo: this.mallNo,
      }
    }
    this.$api.getExchangeProductsProductNo(request).then(async ({ data }) => {
      if((data as any).saleSettingStatusType !== 'AVAILABLE_FOR_SALE') {
        alert(this.$t('CLAIM_EXCHANGEPOPUP_ALTER18').toString());

        return false;
      }

      const {
        partnerName,
        productName,
        salePrice,
        immediateDiscountAmount,
        hasOption,
        optionType,
        accumulationUsed,
        options,
        minBuyCnt,
        maxBuyCountInfo,
      } = data;

      this.partnerName = partnerName
      this.mallProductNo = productNo.toString()
      this.productName = productName
      this.salePrice = salePrice
      this.immediateDiscountAmount = immediateDiscountAmount
      this.mallOptionMap = new Map();
      this.hasOption = hasOption
      this.mallInputs = [];
      this.productType = optionType
      this.accumulationUsed = accumulationUsed
      this.exchangeProductOptions = options
      this.minBuyCount = minBuyCnt;
      this.setMinMaxBuyCountInfo(maxBuyCountInfo);

      await this.$api.getProductsProductNoCustomerDemands({params: {productNo: productNo.toString()}}).then((res: any) => {
        res.data.forEach((productCustomerDemands: CustomerDemands) => {
          this.mallInputs.push({
            mallProductInputNo: productCustomerDemands.inputNo.toString(),
            inputText: productCustomerDemands.inputText,
          })
        })
      })

      if (Number(this.memberNo) !== 0) {
        const { data } = await this.$api.postOrdersBuyCount({
          data: {
            memberNo: Number(this.memberNo),
            maxLimitPersonMallProductNos: [Number(this.mallProductNo)],
            maxLimitPeriodProducts: [],
          },
        });
        this.totalBuyCount = data[0].buyCount;
      }

      await this.$api.getProductsMallProductNoOptions({params: {mallProductNo: this.mallProductNo}}).then((res: any) => {
        this.mallOption = res.data
        this.mallOptionValue = '';
        this.exchangeCnt = '' as any;
        this.optionPrice = '' as any;
        this.optionAmt = '' as any;
        this.saleCnt = 0;
        this.mallOptionValueArr = [{
          name: '옵션을 선택해 주세요.',
          value: ''
        }]
        this.mallOption.forEach(ele => {
          this.mallOptionValueArr.push({
            name: this.getProductOption(ele.optionName, ele.optionValue, ele.stockCnt),
            value: ele.mallOptionNo.toString(),
            disableOption: ele.stockCnt<=0
          });
        });
        if ( this.hasOption==false && (res.data)[0].stockCnt == 0){
          alert(this.$t('CLAIM_EXCHANGEPOPUP_ALTER'));
          return false
        } else {
          res.data.forEach((mallOption: MallOption) => {
            this.exchangeProductOptions.map((res: any) => {
              if(res.mallOptionNo === mallOption.mallOptionNo) {
                (mallOption as any).additionalDiscountAmount = res.additionalDiscountAmount
              }
              this.mallOptionMap.set(mallOption.mallOptionNo.toString(), mallOption);
            })
          });
        }

        // this.mallOptionMap.size == 1 일때만 계산하도록 되어있었음. 옵션 없는 제품을 의미하는 듯 하다.
        if (this.mallOptionMap.size===1) {
          this.mallOptionValue = res.data[0].mallOptionNo.toString()
          let tempMallOption:any = this.mallOptionMap.get(this.mallOptionValue)
          if (tempMallOption){
            this.exchangeCnt = this.getInitialExchangeCnt(tempMallOption)
            this.saleCnt = tempMallOption.stockCnt;
            if (this.orderOptionsApply.claimableOptions[0].mallProductNo.toString() == this.mallProductNo){
              if (this.orderOptionsApply.claimableOptions[0].orderCnt < this.saleCnt){
                this.exchangeCnt = this.orderOptionsApply.claimableOptions[0].orderCnt
              } else{
                this.exchangeCnt = this.saleCnt
              }
            }
            // this.optionPrice = String(this.salePrice - this.immediateDiscountAmount - this.additionalDiscountAmount + tempMallOption.addPrice)
            // this.optionAmt = String((this.salePrice - this.immediateDiscountAmount - this.additionalDiscountAmount + tempMallOption.addPrice) * (this.exchangeCnt))
            this.optionPrice = String(this.salePrice - this.immediateDiscountAmount + tempMallOption.addPrice)
            this.optionAmt = String((this.salePrice - this.immediateDiscountAmount + tempMallOption.addPrice) * (this.exchangeCnt))
            this.optionAddPrice = String(tempMallOption.additionalDiscountAmount)

          } else {
            this.saleCnt = 0
            this.optionPrice = ''
            this.optionAmt = ''
            this.mallOptionValue = null
          }
          this.$emit('setData');
        }
        this.noData = false;
      })

    })
  }

  private setMinMaxBuyCountInfo({ maxBuyDays, maxBuyPeriodCnt, maxBuyPersonCnt, maxBuyTimeCnt }: MaxBuyCountInfo) {
    this.maxBuyDays = maxBuyDays;
    this.maxBuyPeriodCount = maxBuyPeriodCnt;
    this.maxBuyPersonCount = maxBuyPersonCnt;
    this.maxBuyTimeCount = maxBuyTimeCnt;
  }

  private getProductOption(name, value, stockCnt) {
    let optionName = name.split('|');
    let optionValue = value.split('|');
    let optionFullName = []

    for(let i=0; i<optionName.length; i++) {
      optionFullName[i] = optionName[i] + ':' + optionValue[i] + this.showSlodOut(stockCnt);
    }

    return optionFullName.join(' | ')
  }

  private exchangeCnt: number = 1;
  private partnerName: string = ''
  private mallProductNo: string = '';
  private productName: string = ''
  private mallOption: MallOption[]=[];
  private mallOptionMap: Map<string, MallOption> = new Map() ;
  private salePrice: number = 0
  private immediateDiscountAmount: number = 0
  private additionalDiscountAmount: number = 0
  private optionPrice: string = ''
  private optionAmt: string=''
  private optionAddPrice: string=''
  private hasOption: boolean = false
  private productType: string = '';
  private mallInputs:{
    mallProductInputNo: string;
    inputText:string;
  }[] = [];
  private listMallInput:string[]=[]
  private callback(items: any) {
    this.noData = true;
    (window as any).displayExchangeProductOptionInputArea = undefined;
    let productList = items.map(async (item: any): Promise<any> => {
      this.partnerName = item.partnerName
      this.mallProductNo = item.mallProductNo
      this.productName = item.productName
      this.salePrice = item.salePrice
      this.immediateDiscountAmount = item.immediateDiscountAmount
      this.mallOptionMap = new Map();
      this.hasOption = item.hasOption
      this.mallInputs = [];
      this.productType = item.optionType

      let request: GetExchangeProductsProductNoRequest = {
        pathParams: {
          productNo: item.mallProductNo
        },
        params: {
          mallNo: this.mallNo,
        }
      }

      await this.$api.getExchangeProductsProductNo(request).then(async (ret) => {
        this.accumulationUsed = ret.data.accumulationUsed
        this.exchangeProductOptions = ret.data.options
      })

      await this.$api.getProductsProductNoCustomerDemands({params: {productNo: item.mallProductNo}}).then((res: any) => {
        res.data.forEach((productCustomerDemands: CustomerDemands) => {
          this.mallInputs.push({
            mallProductInputNo: productCustomerDemands.inputNo.toString(),
            inputText: productCustomerDemands.inputText,
          })
        })
      })

      await this.$api.getProductsMallProductNoOptions({params: {mallProductNo: this.mallProductNo}}).then((res: any) => {
        this.mallOption = res.data
        this.mallOptionValue = '';
        this.exchangeCnt = 1;
        this.saleCnt = 0;
        this.optionPrice = '';
        this.optionAmt = '';
        this.mallOptionValueArr = [{
          name: '옵션을 선택해 주세요.',
          value: ''
        }]
        this.mallOption.forEach(ele => {
          this.mallOptionValueArr.push({
            name: this.getProductOption(ele.optionName, ele.optionValue, ele.stockCnt),
            value: ele.mallOptionNo.toString(),
            disableOption: ele.stockCnt<=0
          });
        });
        if ( this.hasOption==false && (res.data)[0].stockCnt == 0){
          alert(this.$t('CLAIM_EXCHANGEPOPUP_ALTER'));
          return false;
        } else {
          res.data.forEach((mallOption: MallOption) => {
            this.exchangeProductOptions.map((res: any) => {
              if(res.mallOptionNo === mallOption.mallOptionNo) {
                (mallOption as any).additionalDiscountAmount = res.additionalDiscountAmount
              }
              this.mallOptionMap.set(mallOption.mallOptionNo.toString(), mallOption);
            })
          });
        }

        // this.mallOptionMap.size == 1 일때만 계산하도록 되어있었음. 옵션 없는 제품을 의미하는 듯 하다.
        if (this.mallOptionMap.size===1){
          this.mallOptionValue = res.data[0].mallOptionNo.toString()
          let tempMallOption:any = this.mallOptionMap.get(this.mallOptionValue)
          if (tempMallOption){
            this.exchangeCnt = this.getInitialExchangeCnt(tempMallOption)
            this.saleCnt = tempMallOption.stockCnt;
            this.optionPrice = String(this.salePrice - this.immediateDiscountAmount + tempMallOption.addPrice)
            this.optionAmt = String((this.salePrice - this.immediateDiscountAmount + tempMallOption.addPrice) * (this.exchangeCnt))
            this.optionAddPrice = String(tempMallOption.additionalDiscountAmount)

            if (this.orderOptionsApply.claimableOptions[0].mallProductNo.toString() == this.mallProductNo){
              if (this.orderOptionsApply.claimableOptions[0].orderCnt < this.saleCnt){
                this.exchangeCnt = this.orderOptionsApply.claimableOptions[0].orderCnt
              } else{
                this.exchangeCnt = this.saleCnt
              }
            }
          } else {
            this.saleCnt = 0
            this.optionPrice = ''
            this.optionAmt = ''
            this.optionAddPrice = ''
            this.mallOptionValue = null
          }
          this.$emit('setData');
        }
        this.noData = false;
      })
      
    });
  }

  private showSlodOut(stockCnt:number): string{
    return stockCnt<=0?' [품절]':'';
  }

  private onChangedMallOption(){
    let tempMallOption:any = this.mallOptionMap.get(this.mallOptionValue)
    this.exchangeCnt = this.getInitialExchangeCnt(tempMallOption)
    this.beforeExchangeCnt = this.getInitialExchangeCnt(tempMallOption);

    if (tempMallOption){
      this.saleCnt = tempMallOption.stockCnt;
      this.optionPrice = String(this.salePrice - this.immediateDiscountAmount + tempMallOption.addPrice)
      this.optionAmt = String((this.salePrice - this.immediateDiscountAmount + tempMallOption.addPrice) * (this.exchangeCnt))
      this.optionAddPrice = String(tempMallOption.additionalDiscountAmount)

      if (this.orderOptionsApply.claimableOptions[0].mallProductNo.toString() == this.mallProductNo){
        if (this.orderOptionsApply.claimableOptions[0].orderCnt < this.saleCnt){
          this.exchangeCnt = this.orderOptionsApply.claimableOptions[0].orderCnt
        } else{
          this.exchangeCnt = this.saleCnt
        }
      }
    } else {
      this.saleCnt = 0
      this.optionPrice = ''
      this.optionAmt = ''
    }
    this.$emit('setData');
  }

  // 교환상품 선택할 때, 첫 exchangeCnt 결정하는 메서드
  private getInitialExchangeCnt(mallOption: any){ //  mallOption을 기존코드가 temp에 담아쓰고 있어 any
    if(mallOption === undefined){
      return 0;
    }
    return mallOption.stockCnt < this.orderOptionsApply.claimableOptions[0].orderCnt ? mallOption.stockCnt : this.orderOptionsApply.claimableOptions[0].orderCnt;
  }

  private beforeTotalBuyCount = this.totalBuyCount - this.beforeExchangeCnt;

  private get isExceedMaxBuyPeriodCount(): boolean {
    return this.maxBuyPeriodCount && Number(this.exchangeCnt) + this.beforeTotalBuyCount > this.maxBuyPeriodCount;
  }

  private get isExceedMaxBuyPersonCount(): boolean {
    return this.maxBuyPersonCount && Number(this.exchangeCnt) + this.beforeTotalBuyCount > this.maxBuyPersonCount;
  }

  private get isExccedMaxBuyTimeCount(): boolean {
    return this.maxBuyTimeCount && Number(this.exchangeCnt) > this.maxBuyTimeCount;
  }

  private onExchangeCnt(){
    if (this.exchangeCnt < this.minBuyCount) {
      confirm(this.$t('CLAIM_EXCHANGEPOPUP_CLAIM_MIN_BUY_COUNT_BELOW_MESSAGE').toString());
    }

    if(this.exchangeCnt < 1){
      alert(this.$t('CLAIM_EXCHANGEPOPUP_CLAIM_EXCHANGE_MINIMUM_MESSAGE'))
      this.exchangeCnt = 1
    }

    /**
     * 1인, 1회, 기간제한의 최대구매수량에 대한 설정 시 입금대기건 부터 수량을 체크하여 교환 시 수량 체크
     */
    if (this.isExceedMaxBuyPeriodCount || this.isExceedMaxBuyPersonCount || this.isExccedMaxBuyTimeCount) {
      if (!confirm(this.$t('CLAIM_EXCHANGEPOPUP_CLAIM_MAX_BUY_COUNT_ABOVE_MESSAGE').toString())) {
        this.exchangeCnt = this.exchangeCnt - 1;
      }
    }

    if(this.exchangeCnt > this.saleCnt){
      alert(this.$t('CLAIM_EXCHANGEPOPUP_CLAIM_EXCHANGE_MAXIMUM_MESSAGE', {num: this.saleCnt}))
      this.exchangeCnt = this.saleCnt
    }

    let parentRefs = this.$parent.$refs as any;
    parentRefs.componentProductExchangeDetails.exchangeProductAmtAdjustAmt = 0;
    parentRefs.componentProductExchangeDetails.exchangeProductAmtAdjustReason = '';

    let tempMallOption:any = this.mallOptionMap.get(this.mallOptionValue)
    if (tempMallOption){
      this.optionAmt = String((this.salePrice - this.immediateDiscountAmount + tempMallOption.addPrice) * (this.exchangeCnt))
    }
    this.$emit('setData');
  }

  private onClickRemove(){
    if (this.deleteCheck === false){
      alert(this.$t('CLAIM_EXCHANGEPOPUP_ALTER1'))
    } else {
      this.deleteCheck = false
      this.mallOptionValue = null;
      this.noData = true;
    }
    this.checkedExchangesProduct = false;
    this.$emit('clearData');
  }

  private showOption(optionName:string, optionValue:string){
    let opName: string[]= optionName.split('|');
    let opValue: string[] = optionValue.split('|');
    let returnValue = '';
    for(var i=0; i < opName.length ; i++){
      returnValue = returnValue + opName[i] + ':' + opValue[i] + '|'
    }

    return returnValue.substring(0,returnValue.length-1);
  }
}
